import { Table, TableBody, TableContainer, TableRow } from '@mui/material';
import { useTranslation } from 'react-i18next';

import { Checkbox } from 'common/components/Checkbox';
import { TableCell, TableHead } from 'common/components/Table';
import { IUserListItemFragment } from 'graphql/types';
import { Typography } from 'common/components/Typography';

interface IProps {
    selectedUsers: IUserListItemFragment[];
    onDeSelectUser?: (userId: string) => void;
}

export const SelectedUsersTable = ({
    selectedUsers,
    onDeSelectUser,
}: IProps) => {
    const [translate] = useTranslation();

    return (
        <>
            <Typography sx={{ mb: 2 }} variant="h6">
                {translate('selected')}
            </Typography>

            <TableContainer>
                <Table>
                    <TableHead>
                        <TableRow>
                            <TableCell colSpan={2} />
                        </TableRow>
                    </TableHead>

                    <TableBody>
                        {selectedUsers?.map((user) => (
                            <TableRow key={user.id}>
                                <TableCell padding="checkbox" sx={{ py: 0 }}>
                                    <Checkbox
                                        checked
                                        onClick={() => {
                                            onDeSelectUser?.(user.id);
                                        }}
                                    />
                                </TableCell>

                                <TableCell>{user.name}</TableCell>
                            </TableRow>
                        ))}
                    </TableBody>
                </Table>
            </TableContainer>
        </>
    );
};
